import React from 'react';
import { Route } from 'react-router-dom';
import errorRoutes from '../../router/errorRoutes';
import ThemeProvider from '../../shared/theme/ThemeProvider';

export default function Errors() {
  return (
    <ThemeProvider>
      <>
        {errorRoutes.map((route, index) => {
          const Component = route.component;
          return (
            <Route path={route.path} key={index}>
              <Component />
            </Route>
          );
        })}
      </>
    </ThemeProvider>
  );
}
